import gql from "graphql-tag";

const CONCRETE_SHIPMENT_REPORT_QUERY = gql`
  query ConcreteShipmentsQuery($limit: Int!, $offset: Int!, $orderBy: String!) {
    concreteShipments(limit: $limit, offset: $offset, orderBy: $orderBy) {
      id
      startTime
      loadingEndTime
      quantity
      code
      sealNumber
      canceledAt
    }
  }
`;

export default CONCRETE_SHIPMENT_REPORT_QUERY;
